import { styled, ToggleButton } from '@mui/material';

const StyledToggleButton = styled(ToggleButton)(({ theme }) => ({
  color: theme.palette.grey[400],
  textTransform: 'none',
  fontSize: 14,
  fontWeight: 'normal',
  '&.Mui-selected': {
    backgroundColor: theme.palette.grey[50],
    borderColor: theme.palette.grey[50],
    color: theme.palette.grey[900],
  },
  '&.Mui-selected:hover': {
    color: theme.palette.grey[50],
  },
}));

export default StyledToggleButton;
